import React, { useState } from 'react'
import { NavLink } from 'react-router-dom'
import classes from './DrawerAccordion.module.css'
import leftDrawerImg from '../../assets/piktogram.png'
import ModalVideo from 'react-modal-video'
import 'react-modal-video/scss/modal-video.scss'

interface Props {
  data: any;
  baselink?: string;
}

interface ParElement {
  content: string;
  url?: string
}

interface DrawerSubChild {
  headline: string;
  number: string;
  pars: ParElement[],
  url: string;
}

interface DrawerChild extends DrawerSubChild {
  children: DrawerSubChild[]
}

interface DrawerProps {
  number: string;
  references?: string;
  headline: string;
  pars?: ParElement[];
  showIcon?: boolean
  children?: JSX.Element | JSX.Element[] | JSX.Element[][] | null | DrawerChild[];  //JSX.Element | JSX.Element[] | JSX.Element[][] | null;
  marginLeft?: number;
  isLink?: boolean;
  slug?: string;
  url: string;
  videoCode: string;
  // id: string
  baselink?: string;
}

interface LevelOneDrawer {
  number: string;
  references: string;
  headline: string;
  pars: ParElement[];
  children: DrawerChild[];
  slug?: string;
  headline_url: string;
  video_code: string;
  // doplnit id
}

// doplnit id a slug
const Drawer = ({ number, headline, pars, children, slug, marginLeft, url, videoCode, isLink = true, baselink = "rrzj" }: DrawerProps) => {

  const [modal, setModal] = useState(false);

  const openModal: React.MouseEventHandler<HTMLImageElement> = (e) => {
    e.preventDefault()
    e.stopPropagation()
    setModal(!modal);
  };

  function createHeadline() {
    return { __html: headline };
  }

  const drawerElement = (
    <div className={classes.wrapper}>
      <div className={classes.innerWrapper}>
        <span style={{ marginLeft }} className={classes.number}>{number}</span>
        {videoCode ? <div className={classes.img} onClick={openModal} /> : null}
        <ModalVideo youtube={{ autoplay: 1, mute: 1 }} channel='youtube' isOpen={modal} videoId={videoCode} onClose={() => setModal(false)} />
        <div className={classes.textWrapper}>
          <NavLink to={`/${baselink}/${slug}`} style={{ textDecoration: 'none' }}>
            <h2 className={classes.heading} dangerouslySetInnerHTML={createHeadline()} />
          </NavLink>
        </div>
      </div>
    </div>
  )

  return drawerElement;
}


const Chapters = ({ data, baselink = "rrzj" }: Props) => {
  const levelOneDrawers = data.map((levelOneDrawer: LevelOneDrawer) => {
    return (
      <Drawer
        // id={levelOneDrawer.id}
        number={levelOneDrawer.number}
        headline={levelOneDrawer.headline}
        key={levelOneDrawer.number}
        pars={levelOneDrawer.pars}
        url={levelOneDrawer.headline_url}
        showIcon={!!levelOneDrawer.children.length}
        slug={levelOneDrawer.slug}
        videoCode={levelOneDrawer.video_code}
        baselink={baselink}
      >
      </Drawer>
    )
  })

  return (
    <div className={classes.accordionWrapper}>
      {levelOneDrawers}
    </div>
  )
}

export default Chapters;